import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedUsers from './viewRelatedUsers';

export default {
  attributeName: 'relatedDevices',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  newButton: false,
  getURL: 'devices',
  sessionParams: [],
  emptyMessage: "You don't have any devices yet.",
  fields: [
    {
      attributeName: 'inventoryId',
      label: 'Inventory IDs',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      canFilter: true,
      helpText: 'Unique device identifier. (Inventory)',
      width: '14rem',
    },
    {
      attributeName: 'deviceId',
      label: 'Device IDs',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      canFilter: true,
      helpText: 'Unique device identifier. (Device)',
      width: '14rem',
    },
    {
      attributeName: 'deviceType',
      label: 'Device Types',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      canFilter: true,
      helpText: 'VR device model.',
      width: '14rem',
    },
    {
      attributeName: 'user',
      label: 'User',
      type: FormInputTypes.RELATIONSHIP,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      canFilter: true,
      helpText: 'User currently assigned to this device (can be empty).',
      configFile: viewRelatedUsers,      
      width: '14rem',
    },
    {
      attributeName: 'tags',
      label: 'Tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      canFilter: true,
      helpText: 'Optional tags for the device.',
      width: '14rem',
    },
  ],
};
